<template>
  <component
      :is="component"
      :class="className"
      :type="type"
      :disabled="loading || disabled"
      :to="to"
      v-on="$listeners"
      tabindex="100"
  >
      <div class="btn-loader" v-if="loading">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
      </div>
      <slot v-else></slot>
  </component>
</template>

<script>

import { VBtn } from 'vuetify/lib';

export default {
  name: 'loaderButton',

  components: {
    VBtn,
  },

  props: {
    className: {
      type: String,
      default: null,
    },
    component: {
      type: String,
      default: 'button',
    },
    type: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    to: {
      default: null,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" src="./style.scss"></style>
